import { defineMessages } from 'react-intl';

/**
 * Shared message descriptors for the lifted Weight and Dimensions inputs.
 * IDs are auto-written by `formatjs/enforce-id` on lint.
 */
export const inputMessages = defineMessages({
  weightLabel: {
    defaultMessage: 'Weight',
    id: 'SIUFri',
    description: 'Label for weight input field',
  },
  lengthLabel: {
    defaultMessage: 'length',
    id: '8ew57j',
    description: 'Label for length input field',
  },
  widthLabel: {
    defaultMessage: 'width',
    id: 'aaACwU',
    description: 'Label for width input field',
  },
  heightLabel: {
    defaultMessage: 'height',
    id: 'AGx1J/',
    description: 'Label for height input field',
  },
  zeroPlaceholder: {
    defaultMessage: '0',
    id: '0uRdgW',
    description: 'Placeholder for numeric input',
  },
});
